import React from "react";
import {useSelector} from "react-redux";
import {isEmpty} from "lodash";
import SafeView from "../../components/safeView/SafeView";
import CustomerSelection from "../../components/Modal/CustomerSelection";
import NoOrganization from "../../components/Modal/NoOrganization";
import ProtectedContent, {usePermissionCheck} from "../../components/protectedContent";
import {getCurrentCustomer} from "../../redux/Selectors/customers.selectors";
import {getNotifyError} from "../../redux/Selectors/general.selectors";
import ControllersWithActiveAlert from "./controllersWithActiveAlert";
import FavSystemTable from "./FavSystemTable";
import Hero from "./hero";

const HomePage = () => {
  const currentCustomer = useSelector(getCurrentCustomer);
  const notifyError = useSelector(getNotifyError);

  const canViewCustomer = usePermissionCheck(["view_customer"]);

  if (notifyError) {
    return <NoOrganization />;
  } else if (canViewCustomer && isEmpty(currentCustomer)) {
    return <CustomerSelection />;
  } else {
    return (
      <SafeView>
        <ProtectedContent perms={["view_systeminventory"]}>
          <Hero />
        </ProtectedContent>
        <ProtectedContent perms={["view_systeminventoryfav"]}>
          <FavSystemTable />
        </ProtectedContent>
        <ProtectedContent perms={["view_systeminventoryfav"]}>
          <ControllersWithActiveAlert />
        </ProtectedContent>
      </SafeView>
    );
  }
};

export default HomePage;
